import { PageHero } from "@/components/PageHero";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api } from "@/lib/api";
import { Section } from "@/components/Section";
import SmartImage from "@/components/SmartImage";

const UPCOMING = ["Coming Soon", "Registration Open", "Registration Closed", "Live"];

export default function EventsPage() {
  const [events, setEvents] = useState([]);
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)).catch(() => {}); }, []);
  const upcoming = events.filter((e) => UPCOMING.includes(e.status));
  const past = events.filter((e) => e.status === "Completed");

  return (
    <div data-testid="events-page">
      <PageHero eyebrow="Ironveil Events" title="The Fight Calendar" image="arena" position="center 35%" testId="events-hero">
        Structured MMA and Boxing competition across India — announced, open and completed events.
      </PageHero>

      <Section testId="events-upcoming" title="Upcoming Events" eyebrow="Ongoing & Announced">
        {upcoming.length ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {upcoming.map((e) => <EventCard key={e.id} event={e} />)}
          </div>
        ) : (
          <div className="card-ive p-12 text-center text-[#888]">No upcoming events announced yet.</div>
        )}
      </Section>

      <Section testId="events-past" title="Past Events" eyebrow="Archive">
        {past.length ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {past.map((e) => <EventCard key={e.id} event={e} />)}
          </div>
        ) : (
          <div className="card-ive p-12 text-center text-[#888]">No past events yet.</div>
        )}
      </Section>
    </div>
  );
}

function EventCard({ event }) {
  return (
    <Link to={`/events/${event.slug}`} className="card-ive relative aspect-[4/5] block group overflow-hidden" data-testid={`event-card-${event.slug}`}>
      <SmartImage path={event.poster_path} fallback="ring" alt={event.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
      <div className="absolute top-3 left-3 bg-[#C8102E] type-meta px-2 py-1">{event.status}</div>
      <div className="absolute inset-x-0 bottom-0 p-5 bg-gradient-to-t from-black via-black/80 to-transparent">
        <div className="type-meta text-[#C8102E]">{event.event_number || event.sport}</div>
        <div className="type-card mt-1">{event.title}</div>
        <div className="text-xs text-[#a0a0a0] mt-2">{event.location}</div>
        <div className="mt-3 btn-text type-meta">Explore Event <ArrowRight size={12} /></div>
      </div>
    </Link>
  );
}
